export default __webpack_public_path__ + "static/media/OCGO-slider2.93af1a94.jpg";